import { useForm } from "react-hook-form";
import { ModalReabrirCriativoStyled } from "./style";
import api from "../../../services/api";
import { toast } from "react-toastify";

export const ModalReabrirCriativo = ({ state, criativo, buscarCriativo }) => {
  const { handleSubmit } = useForm()

  function onSubmitFunction(value) {
    value.status = "em andamento"

    api.patch(`/criativo/${criativo.id}`, value)
      .then((response) => {
        buscarCriativo()
        state(false)
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  }

  return (
    <ModalReabrirCriativoStyled >
      <form onSubmit={handleSubmit(onSubmitFunction)} className="div-body">
        <span onClick={() => state(false)} className="close">
          X
        </span>
        <h2>Tem certeza que quer reabrir esse criativo?</h2>
        <h3></h3>
        <div className="buttons">
          <button className="finalizar">reabrir</button>
          <button onClick={() => state(false)} className="cancelar">cancelar</button>
        </div>
      </form>
    </ModalReabrirCriativoStyled>
  );
};